import React, {Fragment} from 'react';
import requestApi from "../../../../services/requestApi.service";
import NoRecord from "../../../../Common/NoRecord";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil} from "@fortawesome/free-solid-svg-icons/faPencil";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import FormHeader from "../../../../Common/FormHeader";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {faXmark} from "@fortawesome/free-solid-svg-icons/faXmark";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {Col, Row} from "react-bootstrap";
import cx from "classnames";
import Select from "react-select";
import {confirmBoxWithImage, 
        parseJSON, 
        removeLastChar, 
        showToast,
        handleErrorResponse,
    } from "../../../../Common/Appcommon";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import ListTable from "../../../../Common/ListTable";

class InteractiveMessageList extends React.Component{

    variationIds = [];
    messageTypes = [
        {
            value : "list", label : "List"
        },
        {
            value: "button", label: "Button"
        }
    ];

    formname = "interactive_messages";

    constructor(props) {
        super(props);
        this.state = {
            listFields : [],
            totalCount : 0,
            limit: process.env.REACT_APP_RECORDS_PER_PAGE,
            page:1,
            type : "interactivemessages",
            rowData : [],
            isOpenModal : props.isModalOpen,
            inputData : {},
            messageType : 'list',
            defaultMessage : this.messageTypes[0],
            messages : [""],
            description : [""],
            maxMessageLimit : 10,
            currentRowId : "",
            variationsCount: 1,
        }
    }

    componentDidMount = async() => {
        await this.loadIAMessages();
    }

    loadIAMessages = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "INTERACTIVE_MESSAGE",
            "SETTINGSNAME" : "GETALL",
            "PAGE": this.state.page,
            "LIMIT": this.state.limit
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "get");
        if (response.issuccess) {
            let data = response.data;
            this.setState({
                rowData: data[0],
                listFields : data[1],
                totalCount : data[2][0]
            })
        }
    }

    handleBtnClick = (type, e, label) => {
        e.preventDefault();
        if(type === "interactive_message"){
            this.setState({
                isOpenModal : true
            })
        }
    }

    onModalClose = () => {

        const { clearErrors, reset } = this.props.hookForm;
        let inputData = this.state.inputData;
        //Clear error messages while closing modal.
        clearErrors();

        //Reset field values while closing modal.
        this.variationIds = [];
        reset({
            inputData : ''
        })
        this.setState({
            isOpenModal : false,
            inputData: {},
            currentRowId : "",
            messageType : 'list',
            description : [""],
            defaultMessage : this.messageTypes[0],
            messages : [""],
            variationsCount : 1
        })
    }

    onOpenModal = async (e, id) => {
        let {rowData} = this.state;
        for(let i = 0; i < rowData.length; i++){
            if(rowData[i]['id'] === id){
                this.setState({
                    isOpenModal : true,
                    inputData:rowData[i],
                })
                this.editMessageData(e, rowData[i]);
            }
        }
    }

    handleInputChange = (e) => {
        let inputData = this.state.inputData;
        let name = e.target.name;
        inputData[name] = e.target.value;
        this.setState({
            inputData: inputData
        })
    }

    onKeyWordInputChange = (e, index) => {
        let messages = this.state.messages;
        let value = e.target.value;
        messages[index] = value;
        this.setState({
            messages
        })
    }

    onKeyWordDescChange = (e, index) => {
        let description = this.state.description;
        let value = e.target.value;
        description[index] = value;
        this.setState({
            description
        });
    }

    addMoreKeywordOptions = (e) =>{
        let { variationsCount, messages, description } = this.state;
        ++variationsCount;
        messages.push("");
        description.push("");
        this.setState({ messages, description, variationsCount });
    }

    removeVariations = (removedIndex, variationId) => {
        let { variationsCount, messages, description } = this.state;

        if(+variationsCount > 1){
            --variationsCount;
            delete messages[variationId];
            delete description[variationId];
            delete this.variationIds.splice(removedIndex, 1);
            this.setState({variationsCount, messages, description});
        }
    }

    onMessageTypeChange = (selectedOption) => {
        let {inputData} = this.state;
        let maxMessageLimit = selectedOption.value === "button" ? 3 : 10;
        inputData["messageType"] = selectedOption.value;
        this.variationIds = [];
        this.setState({
            defaultMessage : selectedOption,
            maxMessageLimit,
            inputData,
            variationsCount : 1,
            messages : [""],
            description : [""],
        })
    }

    submitForm = async (data) => {
        let {inputData, messages, description, defaultMessage, variationsCount, maxMessageLimit} = this.state;
        const { reset } = this.props.hookForm;

        let input = [];
        let desc = [];
        //Reset listname when type is button
        if(defaultMessage.value !== undefined && defaultMessage.value === "button"){
            inputData['list_name'] = "";
        }

        if(variationsCount > 0){
            let maxVariationId = (+this.variationIds[this.variationIds.length - 1]);
            for (let i = 0; i <= maxVariationId; i++){
                if(messages[i] !== undefined){
                    //Input count should be less than max limit.
                    if(+Object.keys(input).length >= +maxMessageLimit){
                        break;
                    }

                    //handle " quotes inside content.
                    /*if(messages[i] != null){
                        messages[i] = messages[i].replaceAll('"','\\"');
                    }*/
                    input.push(messages[i]);
                }

                /*if(description[i] !== undefined){
                    if( description[i] === null){
                        desc.push('');
                    }else{
                        if(description[i] != null){
                            description[i] = description[i].replaceAll('"','\\"');
                        }
                        desc.push(description[i]);
                    }
                }*/
            }
        }

        //reset description when button option selected since fb don't support description in button.
        if(defaultMessage.value !== undefined && defaultMessage.value === "button"){
            desc = [];
        }

        messages = input;
        //description = desc;

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "INTERACTIVE_MESSAGE",
            "SETTINGSNAME" : inputData['id'] === undefined || inputData['id'] === "" ? "SAVE_CONFIG" : "UPDATE_CONFIG",
            "input" : inputData,
            "messages" : messages,
            "description" : description,
            "messageType" : defaultMessage,
        };

        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if (response.issuccess) {
            let messageStr = "Updated";
            if(inputData['id'] === undefined || inputData['id'] === ""){
                messageStr = "Created";
            }
            showToast("Message "+messageStr+" Successfully.");

            reset({inputData : {}});

            this.setState({
                rowData : [],
                inputData : {},
                messageType : 'list',
                defaultMessage : this.messageTypes[0],
                messages : [""],
                description : [""],
                maxMessageLimit : 10,
                currentRowId : "",
                variationsCount: 1,
                isOpenModal : false,
            })
            await this.loadIAMessages();
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    editMessageData = (e, rowData) => {

        let {variationsCount} = this.state;

        let inputData = {};
        let currentRowId = rowData['id'];
        inputData['name'] = rowData['name'];
        inputData['list_name'] = rowData['list_name'];
        inputData['id'] = currentRowId;
        let messageValue = rowData['message_type'];
        let messageLabel = "List";
        if(messageValue !== null && messageValue !== "") {
            messageLabel = messageValue.charAt(0).toUpperCase() + messageValue.slice(1);
        } else {
            messageValue = "list";
        }
        let defaultMessage = {value : messageValue, label : messageLabel};
        let keywords = rowData['keywords'];
        keywords = parseJSON(keywords);

        let description = rowData['description'];
        if(description !== undefined && description !== null){
            description = parseJSON(description);
        }else{
            description = [''];
        }

        keywords = keywords.filter(item => item !== null);
        description = description.filter(item => item !== null);

        this.variationIds = [];
        variationsCount = 0;

        for(let i = 0; i < Object.keys(keywords).length; i++){
            this.variationIds.push(i);
            variationsCount++;
        }

        let maxMessageLimit = (messageValue === "button") ? 3 : 10;

        this.setState({
            inputData,
            defaultMessage,
            messages: keywords,
            description: description,
            messageType: messageValue,
            isOpenModal : true,
            currentRowId,
            maxMessageLimit,
            variationsCount
        })
    }

    deleteMessageData = async (e, id) => {
        let isConfirm = await confirmBoxWithImage("Delete","Are you sure you want to delete?","");
        if(isConfirm) {
            e.preventDefault();
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "INTERACTIVE_MESSAGE",
                "SETTINGSNAME": "DELETE",
                "formid": id,
            };

            let response = await requestApi.processServerRequest(params, "WebV2", "post");
            if (response.issuccess) {
                showToast("Message deleted Successfully.");
                this.setState({
                    rowData : [],
                    inputData : {},
                    messageType : 'list',
                    defaultMessage : this.messageTypes[0],
                    messages : [""],
                    description : [""],
                    maxMessageLimit : 10,
                    currentRowId : "",
                    variationsCount: 1,
                    isOpenModal : false,
                })
                await this.loadIAMessages();
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }

    renderElements = (name,formData) => {

        if(name === 'name'){
            let name = formData['name'];

            return(
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-message'}>{name}</span>
                    </div>
                </>
            )

        } else if(name === 'messagetype'){
            let messagetype = formData['message_type'];
            return(
                <>
                    <div className={`d-grid text-center`}>
                        <span className={'template-primary'}>{messagetype.toUpperCase()}</span>
                    </div>
                </>
            )
        } else if(name === 'listname'){
            let listname = formData['list_name'];
            return(
                <>
                    <div className={`d-grid text-center`}>
                        <span className={'template-primary'}>{listname}</span>
                    </div>
                </>
            )
        } else if(name === 'keywords'){
            let keywords = formData['keywords'];
            if(keywords !== ""){
                keywords = parseJSON(keywords);
            }
            let keywordStr = "";
            if(keywords !== undefined) {
                keywords.map((keyword, index) => {
                    keywordStr += keyword + ", ";
                })
            }
            keywordStr = removeLastChar(keywordStr.trim());
            return(
                <>
                    <div className={`d-grid text-center`}>
                        <span className={'template-primary'}>{keywordStr}</span>
                    </div>
                </>
            )
        }
    }

    onListMsgDelete = async () => {
        showToast("Deleted Successfully!",'top-right','success');
        await this.loadIAMessages();
    }

    onPageChange = (page) => {
        this.setState({page},async ()=>{
            await this.loadIAMessages();
        });
    }

    render() {
        let buttonOptions = [
            {
                name: 'interactive_message',
                label: 'Add New',
                icon: faCirclePlus
            }
        ]
        let {isOpenModal,inputData, messages, description, rowData, variationsCount, maxMessageLimit, totalCount, limit, listFields , page} = this.state;
        const {handleSubmit,control, formState: { errors } } = this.props.hookForm;
        const ControllerComp = this.props.controller;

        if(listFields === undefined){
            return <></>;
        }

        let customRowConfig = {
            link : {
                onClick : this.onOpenModal,
                condition : "",
                class : "row-link list-row-height"
            }
        };
        
        listFields =[['Name', 'Message Type', 'List Name', 'Keywords'],['Name','Message Type', 'List Name','Keywords']];

        let customFieldConfig = {
            "Name" : {
                "render" : "name",
                "class" : "template-name",
            },
            "Message Type" : {
                "render" : "messagetype",
                "class": "text-center",
            },
            "List Name" : {
                "class": "text-center",
                "render" : "listname",
            },
            "Keywords" : {
                "render" : "keywords",
                "class" : "text-left",
            },
        };

        let headerFieldConfig = {
            "Name" : {
                "class" : "text-left w-4"
            },
            "Message Type" : {
                "class" : "text-center w-4"
            },
            "List Name" : {
                "class" : "text-center w-4"
            },
            "Keywords" : {
                "class" : "text-center"
            }
        };

        let variationList = [];
        for(let i = 0; i < variationsCount; i++){
            let variationId = undefined;

            if(+i >= +maxMessageLimit){
                break;
            }

            if(this.variationIds[i] !== undefined){
                variationId = this.variationIds[i];
            }else{

                //create new variation id when id not found previously. This will be the last_max_value+1.
                //If there is no variationId found then start from 0.
                if(this.variationIds.length > 0){
                    variationId = (this.variationIds[this.variationIds.length-1]) + 1;
                }else{
                    variationId = 0;
                }
                this.variationIds[i] = variationId;
            }

            variationList.push(
                <>
                    <ControllerComp
                        name={'message-name-'+variationId}
                        control={control}
                        rules={{
                            required: messages[variationId] && messages[variationId] !== "" && messages[variationId].length > 0 ? false : "Input is required",
                            maxLength: {
                                message: 'Value too long'
                            }
                        }}
                        render={({ field }) => {

                            let messageLength = messages[variationId] !== undefined && messages[variationId] !== null  ? messages[variationId].length : 0;
                            let descriptionLength = this.state.defaultMessage.value === 'list' && description[variationId] !== undefined && description[variationId] !== null ? description[variationId].length : 0;
                            return (
                                <span className={`input-variation`}>
                                    <input
                                        {...field}
                                        type={'text'}
                                        placeholder={'input '+(i+1)}
                                        name={'message-name-'+variationId}
                                        value={messages[variationId]}
                                        autoComplete={"off"}
                                        className={`form-control mb-2 list-btn-title ${errors['message-name-'+variationId] ? 'is-invalid no-image' : ''}`}
                                        onChange={(e) => {
                                            this.onKeyWordInputChange(e, variationId);
                                            field.onChange(e);
                                        }}
                                        maxLength={20}
                                    />
                                    <span className={cx(`input-count mR10`,{
                                             'min-input-count' : messageLength < 10
                                        })}>
                                        {`${messageLength}/20`}
                                    </span>
                                    {this.state.defaultMessage.value === 'list' &&
                                        <>
                                            <input
                                                {...field}
                                                type={'text'}
                                                placeholder={'Description '+(i+1)}
                                                name={'desc-name-'+variationId}
                                                autoComplete={"off"}
                                                value={description[variationId]}
                                                className={`form-control mb-2 col-md-12 interactive list-btn-desc`}
                                                onChange={(e) => {
                                                    this.onKeyWordDescChange(e, variationId);
                                                    field.onChange(e);
                                                }}
                                                maxLength={70}
                                                disabled={messages[variationId] == undefined || messages[variationId] == ""}
                                            />
                                            <span className={cx(`input-count`)}>
                                                {`${descriptionLength}/70`}
                                            </span>
                                        </>
                                    }
                                    {
                                        variationsCount !== 1 &&
                                        <span className={`input-variation-remove ml-2`}>
                                            <FontAwesomeIcon icon={faXmark} className={`mr-1`} onClick={()=>this.removeVariations(i,variationId)}/>
                                        </span>
                                    }
                                </span>
                            );
                        }}
                    />
                    {errors['message-name-'+variationId] && <em className={`error invalid-feedback`}>{errors['message-name-'+variationId]['message']}</em>}
                </>
            )
        }


        return (

            <>
                <Fragment>
                    <div className="listview-container interactive-message-listview kv-main-wrapper h100per">
                        <FormHeader
                            buttonOptions={buttonOptions}
                            handleBtnClick={this.handleBtnClick}
                            headerText={"List Messages/ Reply Buttons"}
                            headerDesc={"Give your customers a simpler way to find and select what they want from your business."}
                        />
                        <div className={'mb-2'}>
                            <ListTable
                                key={Math.random()}
                                formData={rowData}
                                fields={listFields}
                                showRowCount={true}
                                spaceBfCell={false}
                                isActionsNeeded={true}
                                isDeleteNeeded={true}
                                deleteCallBack={this.onListMsgDelete}
                                config={customFieldConfig}
                                customRowConfig={customRowConfig}
                                renderElements={this.renderElements}
                                noDataMsg={`List Message not found`}
                                pagination={true}
                                onPageChange={this.onPageChange}
                                currentPage={page}
                                totalCount={totalCount}
                                limit={limit}
                                customClass={'no-border-table'}
                                headerConfig={headerFieldConfig}
                                formName={this.formname}
                                isTableForm = {false}
                            />
                    </div>
                        {/* <div className={'im-list-container mt-1 mb-3'}>
                            {rowData.length > 0 ? <div className={''}>
                                <div className={'mb-2'}>
                                    <table className={'le-table no-border-table table table-bordered table-hover'}>
                                        <thead>
                                        <tr>
                                            <th className={'w-6'}>#</th>
                                            <th className={'text-left w-4'}>Name</th>
                                            <th className={'text-center w-4'}>Message Type</th>
                                            <th className={'text-center w-4'}>List Name</th>
                                            <th className={'text-left'}>Keywords</th>
                                            <th className={'custom-table-header w-5'}>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            rowData.map((row, index)=>{
                                                let name = row['name'];
                                                let lName = row['list_name'];
                                                let msgType = row['message_type'];
                                                let keywords = row['keywords'];
                                                if(keywords !== ""){
                                                    keywords = parseJSON(keywords);
                                                }
                                                let keywordStr = "";
                                                if(keywords !== undefined) {
                                                    keywords.map((keyword, index) => {
                                                        keywordStr += keyword + ", ";
                                                    })
                                                }
                                                keywordStr = removeLastChar(keywordStr.trim());
                                                return (
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td className={'text-left'}>{name}</td>
                                                        <td className={'text-center'}>{msgType.toUpperCase()}</td>
                                                        <td>{lName}</td>
                                                        <td className={'text-left'}>{keywordStr}</td>
                                                        <td>
                                                            <div className={'d-flex-alone justify-center'}>
                                                                <div className={'p-2'}>
                                                                    <a className={'cursor-pointer'} onClick={(e) => {this.editMessageData(e, row)}}><FontAwesomeIcon icon={faPencil} /></a>
                                                                </div>
                                                                <div className={'p-2'}>
                                                                    <a className={'cursor-pointer'} onClick={(e) => {this.deleteMessageData(e, row['id'])}}><FontAwesomeIcon icon={faTrash} /></a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : <NoRecord msg={"No data found"}/>}
                        </div> */}
                    </div>
                    <div className={'interactive-message-modal'}>
                        <Modal size={"lg"} isOpen={isOpenModal}  toggle={this.onModalClose} >
                            <form name={'interactive_message'} onSubmit={handleSubmit(this.submitForm)}>
                                <ModalHeader toggle={this.onModalClose}>
                                    {inputData['id'] === undefined || inputData['id'] === "" ? "Create List Messages/ Reply Buttons" : "Update List Messages/ Reply Buttons"}
                                </ModalHeader>
                                <ModalBody>
                                    <Row className={'mb-3'}>
                                        <Col md="8" className={cx('pr-0 d-grid ')}>
                                            <label className={'group-header-lbl mb-1'} htmlFor="name">Provide a Name*</label>
                                            <ControllerComp
                                                name="name"
                                                control={control}
                                                rules={{ required: inputData.name !== undefined && inputData.name !== "" ? false : "Interactive Message Name is required"}}
                                                render={({ field }) => {
                                                    return (
                                                        <input
                                                            {...field}
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            value={inputData.name !== undefined ? inputData.name : ""}
                                                            autoComplete={"off"}
                                                            onChange={(e) => {
                                                                this.handleInputChange(e);
                                                                field.onChange(e);
                                                            }}
                                                            className={`form-control list-msg-text-box ${errors.name ? 'is-invalid' : ''}`}
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.name && <em className={`error invalid-feedback`}>{errors.name.message}</em>}
                                        </Col>
                                    </Row>
                                    <Row className={'mb-3'}>
                                        <Col md={'8'}>
                                            <label className={'group-header-lbl mb-1'} htmlFor="messageType">Message Type</label>
                                            <Select 
                                                name="messageType" 
                                                className={"message-type list-msg-text-box"} 
                                                classNamePrefix="wa-select" 
                                                id={`message_type`} 
                                                value={this.state.defaultMessage} 
                                                onChange={(e) => {
                                                    this.onMessageTypeChange(e)
                                                }} 
                                                options={this.messageTypes}
                                            />
                                        </Col>
                                    </Row>
                                    {this.state.defaultMessage.value === 'list' && <Col md="8" className={cx('pr-0 d-grid ')}>
                                        <label className={'group-header-lbl mb-1'} htmlFor="list_name">List Messages Menu Name*</label>
                                        <ControllerComp
                                            name="list_name"
                                            control={control}
                                            rules={{ required: inputData.list_name !== undefined && inputData.list_name !== "" ? false : "Interactive List Name is required",
                                                    maxLength: {
                                                        value: 20,
                                                        message: 'Value too long'
                                                    }
                                            }}
                                            render={({ field }) => {

                                                let messageLength = inputData.list_name !== undefined ? inputData.list_name.length : 0;

                                                return (
                                                    <span className={`input-variation`}>
                                                        <input
                                                            {...field}
                                                            type="text"
                                                            name="list_name"
                                                            id="interactive-list-name"
                                                            value={inputData.list_name !== undefined ? inputData.list_name : ""}
                                                            autoComplete={"off"}
                                                            onChange={(e) => {
                                                                this.handleInputChange(e);
                                                                field.onChange(e);
                                                            }}
                                                            className={`form-control list-msg-text-box ${errors.list_name ? 'is-invalid no-image' : ''}`}
                                                            maxLength={20}
                                                        />
                                                        <span className={cx(`input-count`,{
                                                            'min-input-count' : messageLength < 10
                                                        })}>{`${messageLength}/20`}</span>
                                                    </span>
                                                );
                                            }}
                                        />
                                        {errors.list_name && <em className={`error invalid-feedback`}>{errors.list_name.message}</em>}
                                    </Col>}
                                    <Row className={'mb-3'}>
                                        <div className={'keyword-controls '}>
                                            <label className={'group-header-lbl mb-1'} htmlFor="keywords_list">List/ Button Input</label>
                                            {
                                                variationList &&
                                                variationList.length > 0 &&
                                                variationList.map((variation)=>{
                                                    return variation;
                                                })
                                            }
                                        </div>
                                    </Row>
                                    <div className={'button-panel'}>
                                        <a className={`cursor-pointer option-addmore ${variationsCount >= this.state.maxMessageLimit ? 'btn-disabled' : ''}`} onClick={(e) => {this.addMoreKeywordOptions(e)}}><FontAwesomeIcon icon={faPlus} /> <span>Add More</span></a>
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button size={"md"} color={'success'} type={"Submit"}>Save & Close</Button>
                                </ModalFooter>
                            </form>
                        </Modal>
                    </div>

                </Fragment>
            </>
        )
    }

}
export default InteractiveMessageList;
